import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { RolElement, UserElement } from '../models/user.model';
import { UserService } from '../services/user.service';
import { MenusComponent } from './../menus/menus.component';
import { MatPaginator } from '@angular/material/paginator';
import { StorageService } from '../services/storage.service';

const lstUsers: UserElement[] = [];

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrl: './users.component.css',
})

export class UsersComponent implements OnInit {

  private rowClick$  = new Subject<UserElement>();

  displayedColumns: string[] = ['id', 'first_name', 'last_name', 'email',
                                'role_id'];

  displayedColumns2: string[] = ['id', 'first_name', 'last_name', 'email',
                                'role_id', 'company_id'];


  dataSource = new MatTableDataSource(lstUsers);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private router: Router, private userService: UserService,
              private menusComponent: MenusComponent, private storageService: StorageService) { }

  isLoading = false;

  @ViewChild(MatSort)
  sort: MatSort = new MatSort;
  public superAdm = false;

  items: any = [];
  lstRoles: RolElement[] = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator._intl.itemsPerPageLabel="Registros por página";
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    this.isLoading = true;
    this.lstRoles=this.userService.getRolesListByRole(this.storageService.roleId,
                                                      this.storageService.companyId);

    this.loadUsers();
    this.isLoading = false;
  }

  loadUsers():void {
    const req=this.userService.getAllUsers(this.storageService.companyId);
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: UserElement): void {
    this.rowClick$.next(row);
    this.router.navigate(['user'], { queryParams: { id: row.id, company_id: row.company_id } });
  }
  
  getRoleLabel(roleID: number): string {
    const company = this.lstRoles.find(comp => comp.value === roleID);
    return company ? company.viewValue : 'Unknown';
  }

  getRoleHint(roleID: number): string {
    switch(roleID) {
      case 2:
        return 'Administrador empresa: Puede dar de alta usuarios, trabajadores y proyectos. Puede gestionar y activar dispositivos';
      case 3:
        return `Usuario: Puede gestionar proyectos. Puede gestionar y activar dispositivos`;
      default:
        return "";
    }
  }
}
